<template>
  <div class="setting-advanced-qrcode module-item-style">
    <p class="module-item-title">二维码名片上传</p>
    <p class="tips">名片可以在对话中快捷发送给访客（ 请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg ）</p>
    <div class="setting-advanced-qrcode-upload-container">
      <div class="upload-input">
        <div class="file-name-div">{{selectedFileName}}</div>
        <input type="file" @change="fileChange" v-show="false" ref="fileInput">
        <div class="chose-file" @click="chooseFile">选择名片</div>
      </div>
      <div class="wl-btn" @click="uploadFile">
        上传
      </div>
    </div>
    <div class="setting-advanced-qrcode-list-container">
      <tableMulti
          :tableData="tableData"
          :tableHead="tableHead"
          :tableHandler="tableHandler"
          :total="total"
          :isLoading="isloading"
          :size="pageSize"
          @handleButton="handleOperate"
          @pageHandler="pageOperate"></tableMulti>
    </div>
  </div>
</template>

<script>
  import tableMulti from '@/components/table/table-multi'
  export default {
    name: 'setting-advanced-qrcode',
    components:{
      tableMulti
    },
    data() {
      return {
        isloading:false,
        noSelectFile: '未选中任何名片',
        selectedFileName: '未选中任何名片',
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        uploadFileData: null,
        currentPage: 1,
        pageSize:10,
        tableHandler:[
          {label:"删除",type:'del',methods:'delMethods'},
        ],
        tableData:[],
        tableHead:[
          {
            label: '名称',
            value: 'businessCardDes',
            operate:false
          },{
            label: '操作',
            value: '',
            width:'160',
            operate:true,
          }
        ],
        total: 0
      }
    },
    created() {
      this.getFileList()
    },
    mounted() {

    },
    methods: {
      /**
       * 表单操作
       * @param val
       */
      handleOperate(val){

        let delData = []
        if(val.methods == "delMethods"){
          delData.push(val.row.id)
        }else if(val.methods == 'delAll'){
          if(val.row.length == 0){
            this.$message({
              showClose: true,
              message: '请勾选要删除的二维码名片',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          val.row.map((item) => {
            delData.push(item.id)
          })
        }
        this.delFile(delData)
      },
      /**
       *  分页操作
       * @param val
       */
      pageOperate(val){
        if(val.type == 'currentChange'){
          this.currentPage = val.val
        }else if(val.type == "sizeChange"){
          this.pageSize = val.val
        }
        this.getFileList()
      },
      chooseFile() {
        this.$refs.fileInput.click()
      },
      fileChange(e) {
        let img = e.target.files[0]
        let type = img.type
        let size = img.size
        if (this.accept.indexOf(type) == -1) {
          this.$message({
            showClose: true,
            message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        if (size > 5242880) {
          this.$message({
            showClose: true,
            message: '请选择5M以内的图片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        this.selectedFileName = img.name
        this.uploadFileData = img
      },
      /**
       * 上传二维码名片
       * @returns {boolean}
       */
      uploadFile() {
        if (!this.uploadFileData) {
          this.$message({
            showClose: true,
            message: '请先选择要上传的二维码名片！',
            type: 'error',
            duration: 3 * 1000
          })
          return false
        }
        this.pageSize = 10;
        this.currentPage = 1
        let formdata = new FormData()
        formdata.set('file', this.uploadFileData)

        this.$http.uploadQRCodeAPI(formdata).then(res => {
          if (res.status == 1) {
            this.selectedFileName = '未选中任何名片'
            this.uploadFileData = null
            this.getFileList()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
              duration: 3 * 1000
            })
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '二维码名片上传失败，请重试！',
            type: 'error',
            duration: 3 * 1000
          })
        })
      },
      /**
       * 获取已上传的名片
       */
      getFileList() {
        this.isloading = true
        this.$http.getQRCodelistAPI({
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }).then(res => {
          if (res.status == 1) {
            this.tableData = res.data.list
            this.total = res.data.total
          }
          this.isloading = false
        }).catch(err => {
          console.log(err)
          this.isloading = false
        })
      },
      /**
       * 删除名片
       * @param fileArr
       */
      delFile(fileArr){
        this.$http.delQRCodeAPI({
          cardIds: fileArr
        }).then( res => {
          if(res.status == 1){
              this.getFileList()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
              duration: 3 * 1000
            })
          }else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
              duration: 3 * 1000
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-advanced-qrcode {

    .tips {
      color: #999999;
      font-size: 12px;
      padding-top: 13px;
    }

    .setting-advanced-qrcode-upload-container {
      display: flex;
      padding-top: 25px;

      .upload-input {
        width: 500px;
        border: 1px solid #E4E7ED;
        border-radius: $mainBorderRadius;
        line-height: 40px;
        display: flex;
        margin-right: 30px;

        .file-name-div {
          flex: 1;
          font-size: 12px;
          color: #999;
          padding: 0 15px;
        }

        .chose-file {
          width: 78px;
          text-align: center;
          font-size: 12px;
          color: #333;
          cursor: pointer;
          background-color: #F2F2F2;
        }
      }
    }

    .setting-advanced-qrcode-list-container {
      padding-top: 26px;

    }
  }
</style>
